import { render, staticRenderFns } from "./MerchantBill.vue?vue&type=template&id=3ffaca12"
import script from "./MerchantBill.vue?vue&type=script&lang=js"
export * from "./MerchantBill.vue?vue&type=script&lang=js"
import style0 from "./MerchantBill.vue?vue&type=style&index=0&id=3ffaca12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports